import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React, { PropsWithChildren } from 'react';
import { useLicenceContext } from 'models/licenceContext';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!;

export const ReCaptchaProvider = ({ children }: PropsWithChildren<{}>) => {
  const { isOnlineLicence } = useLicenceContext();

  if (!isOnlineLicence()) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      language="en"
      scriptProps={{
        async: true,
        defer: true,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};
